import { styled } from "@mui/material/styles";
import { DialogActions } from "../../../../dialog";

export const DialogActionsWithoutPadding = styled(DialogActions)`
  padding: 5px 20px;
`;
